import axios from 'axios';

const apiApp = axios.create({
  baseURL: process.env.REACT_APP_API_APP_URL,
});

export default apiApp;
